import { Icons } from '@citygross/icons';
import React from 'react';
import { BoxArrowContainer } from './BoxArrow.styles.js';

var BoxArrow = function BoxArrow(_a) {
  var arrowPlacement = _a.arrowPlacement,
      arrowSpacing = _a.arrowSpacing,
      background = _a.background;
  return React.createElement(BoxArrowContainer, {
    margin: arrowSpacing,
    placement: arrowPlacement
  }, React.createElement(Icons.BoxArrow, {
    width: 17,
    height: 8,
    color: background
  }));
};

export { BoxArrow as default };